import { commonRoutes } from '../../gameConfig/commonRoutes';
import history from './history';

export function getLoginUrls() {
  const allowLoginOnSite = RIO_SITE.game === 'wowretail' || RIO_SITE.external_host.includes('localhost');
  return allowLoginOnSite
    ? {
        mainLoginUrl: '',
        baseNextUrl: '',
        allowLoginOnSite
      }
    : {
        mainLoginUrl: RIO_ALL_SITES.wowretail.external_url,
        baseNextUrl: RIO_SITE.external_url,
        allowLoginOnSite
      };
}

export function doLogin({ hash }: { hash?: string } = {}) {
  const { mainLoginUrl, baseNextUrl, allowLoginOnSite } = getLoginUrls();

  const next = encodeURIComponent(
    baseNextUrl + window.location.pathname + (window.location.search || '') + (hash || window.location.hash || '')
  );

  const loginPath = `${commonRoutes.Login}${next ? `?next=${next}` : ''}`;
  if (allowLoginOnSite) {
    history.push(loginPath);
  } else {
    window.location.href = `${mainLoginUrl}${loginPath}`;
  }
}
